import { render } from "preact";
import "@fontsource-variable/fraunces";
import "@fontsource-variable/figtree";
import "@fontsource/ibm-plex-mono/400.css";
import "@quire/editor/style.css";
import "./styles/tokens.css";
import "./styles/app.css";
import { App } from "./app.ts";
import { Root } from "./ui/root.tsx";

const app = new App();
render(<Root app={app} />, document.getElementById("app")!);
(globalThis as { quire?: App }).quire = app;

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") app.flushQuietly();
  else app.sync();
});
addEventListener("focus", () => app.sync());
addEventListener("pagehide", () => app.flushQuietly());
addEventListener("beforeunload", (e) => {
  if (app.isDirty()) {
    app.flushQuietly();
    e.preventDefault();
  }
});

addEventListener("keydown", (e) => {
  const mod = e.ctrlKey || e.metaKey;
  if (mod && e.key.toLowerCase() === "s") {
    e.preventDefault();
    app.save();
  } else if (mod && e.shiftKey && e.key.toLowerCase() === "k") {
    e.preventDefault();
    app.setPalette(!app.state.get().paletteOpen);
  } else if (mod && e.shiftKey && e.key.toLowerCase() === "f") {
    e.preventDefault();
    app.setFocus(!app.state.get().focus);
  } else if (mod && e.key === "\\") {
    e.preventDefault();
    app.toggleSidebar();
  } else if (e.key === "Escape") {
    const s = app.state.get();
    if (s.altAsk) app.answerAlt(null);
    else if (s.detailsOpen || s.exportOpen) {
      app.setDetails(false);
      app.setExport(false);
    } else if (s.sidebarOpen) app.toggleSidebar(false);
  }
});

addEventListener("dragover", (e) => {
  if (e.dataTransfer?.types?.includes("Files")) e.preventDefault();
});
addEventListener("drop", (e) => {
  // The editor handles pictures dropped on it; the rest of the page imports Markdown files.
  if (e.defaultPrevented || !e.dataTransfer?.files?.length) return;
  e.preventDefault();
  app.importFiles(e.dataTransfer.files);
});

// Offline: the service worker keeps this build's files. It is only built for the real app.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  addEventListener("load", () => {
    navigator.serviceWorker.register("sw.js").catch(() => {});
  });
}

app.start();
